
import { capitalize, defineComponent, PropType } from "vue";
import { Aspect, AspectType } from "@/types";
import { Button, Icon } from "@/shared/ui";
import { useAutoHeight } from "@/shared/composables/useAutoHeight";

interface Data {
	data: Aspect;
}

export default defineComponent({
	name: "EditAspect",
	components: { Icon, Button },
	emits: ["close", "update", "remove"],
	props: {
		aspect: {
			type: Object as PropType<Aspect>,
			required: true,
		},
		mode: {
			type: String,
			required: true,
		},
	},
	setup() {
		return useAutoHeight();
	},
	data(): Data {
		return {
			data: JSON.parse(JSON.stringify(this.aspect)),
		};
	},
	computed: {
		AspectType() {
			return AspectType;
		},
	},
	mounted() {
		this.autoUpdateHeight(this.$refs.title as HTMLTextAreaElement);
		this.autoUpdateHeight(this.$refs.description as HTMLTextAreaElement);
	},
	methods: {
		capitalize,
		remove() {
			this.$emit("remove");
		},
		close() {
			this.$emit("close");
		},
		save() {
			this.$emit("update", this.data);
			this.$emit("close");
		},
	},
});
